var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencyEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.29 123.06L134.29 11.0599C133.541 10.1074 132.586 9.33734 131.497 8.80782C130.407 8.27831 129.211 8.00317 128 8.00317C126.789 8.00317 125.593 8.27831 124.503 8.80782C123.414 9.33734 122.459 10.1074 121.71 11.0599L33.71 123.06C32.6038 124.469 32.0026 126.209 32.0026 128C32.0026 129.791 32.6038 131.531 33.71 132.94L121.71 244.94C122.459 245.892 123.414 246.662 124.503 247.192C125.593 247.721 126.789 247.997 128 247.997C129.211 247.997 130.407 247.721 131.497 247.192C132.586 246.662 133.541 245.892 134.29 244.94L222.29 132.94C223.396 131.531 223.997 129.791 223.997 128C223.997 126.209 223.396 124.469 222.29 123.06ZM136 39.1299L203.42 124.93L136 155.58V39.1299ZM120 155.58L52.58 124.93L120 39.1299V155.58ZM120 173.15V216.87L66.57 148.87L120 173.15ZM136 173.15L189.43 148.86L136 216.86V173.15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyEth);
export default __webpack_public_path__ + "static/media/currency-eth.b0ebbcf3c00ef7ef39d813a45ff55aed.svg";
export { ForwardRef as ReactComponent };